import { render } from "./AccountsRoot.vue?vue&type=template&id=3522b442"
import script from "./AccountsRoot.vue?vue&type=script&lang=js"
export * from "./AccountsRoot.vue?vue&type=script&lang=js"
script.render = render

export default script